import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
//import queryString from 'query-string';

import {api_host} from '../../../../../common/globals/constants';
import CircularProgress from '@material-ui/core/CircularProgress';
// Shared components
import PortletContent from 'components/PortletContent';

import { forwardRef } from 'react';
import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

import Typography from '@material-ui/core/Typography';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {getResponseGeneral} from '../../../../../services/getTimeResponseGeneral'
import moment from 'moment'
import 'moment/locale/es'  
moment.locale('es')

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

class ResponseWeekDay extends Component {
    
    constructor(props) {
        super(props);
        var pdf=false
        if(props.isPdf===true){
            pdf=true
        }
            
        this.state = {
            currentObjectiveId: this.props.location.state.fromObjective.objetivo_id,
            loadObjectiveData: false,
            period: this.props.data.period,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'c',
            hoverData: null,
            lastEvent: [],
            isPdf:pdf,
            statePeriod: this.props.data.range,
            days:['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
            data:[]
        }  
    }

    static getDerivedStateFromProps(props, state) {
        //console.log('derived', moment(props.data.range.startDate).format("Y-MM-DD"), moment(state.statePeriod.startDate).format("Y-MM-DD"))
        //console.log(props.data.range.endDate,state.finalDate)
        if( moment(props.data.range.startDate).format("Y-MM-DD")!==moment(state.statePeriod.startDate).format("Y-MM-DD")){
            return{
                days:['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
                statePeriod:props.data.range,
                isLoading:true,
            }    
        }
        return null
    }

    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if (moment(prevProps.data.range.startDate).format("Y-MM-DD")!==moment(this.state.statePeriod.startDate).format("Y-MM-DD")) {
            this.getDataFromAPI();
        }

    }
    

    getDataFromAPI = () => {  
        const { currentObjectiveId,period, statePeriod } = this.state
        const { fromObjective } = this.props.location.state
        //console.log(fromObjective)
        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        //console.log(statePeriod)
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            //console.log(currentObjectiveId,token,fecha_inicio,fecha_termino)
            getResponseGeneral(currentObjectiveId,token,fecha_inicio,fecha_termino).then(data => {
                if (data.status == 1 || data.status == 5) {
                    localStorage.setItem('isAuthenticated', false);                        
                } else {
                    //Procesa la Data Recibida
                    try {
                        //console.log('  va a process')
                        this.processData(data.Objetivo, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                    } catch (error) {
                        //console.log('error')
                        this.setState({
                            dataError: true,
                            isLoading: false
                        });
                    }
                }  
            })
        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        fecha_inicio,
        fecha_termino) => {
        const {days}=this.state
        //console.log('process',externalData)
        const colors = ['#2199e8', '#fed12d', '#ff7373', '#ccff00', '#b6fcd5',
            '#065535', '#ffc0cb', '#008080', '#00ffff', '#ffa500',
            '#800000', '#fff68f', '#bada55', '#8a2be2', '#3b5998'];
        var listStepDays=days
        var listDataDays=[]
        listStepDays.map((i,ele)=>{
            //console.log(ele, '---',i)
            externalData.Paso.map(paso=>{
                //console.log(paso.paso_nombre)
                var dict={}
                dict["dia"]=i
                dict["paso"]=paso.paso_nombre
                listStepDays.push({'paso':paso.paso_nombre})
                const groups = paso.rendimientoDetalle.reduce((groups, game) => {
                    var date=parseInt(moment(game.inicio).day())
                    if (!groups[date]) {
                      groups[date] = [];
                    }
                    groups[date].push(game);
                    return groups;
                  }, {});
                var max=0
                var min = +Infinity
                var average=0
                var cont=0
                //console.log(groups[ele])
                Object.keys(groups[ele]).map(data=>{
                    var response=(groups[ele][data].respuesta)
                    //console.log(response)
                    if(response>max){
                        max=response
                    }
                    if(response<min){
                        min=response
                    }
                    average=average+response
                    cont=cont+1
                })
                //console.log(max, min, average/cont)
                dict["max"]=max
                dict['min']=min
                dict['prom']= parseFloat((average/cont).toFixed(2))
                listDataDays.push(dict)
            })
        })
        //console.log('process', listDataDays)
        this.setState({
            data:listDataDays,
            dataError: false,
            isLoading: false,
        });

    }
    render() {
        const { dataError, chartOptions, isLoading, data, isPdf } = this.state;
        //console.log('render',dataError, isLoading)
        var defaultData=0
        var options={
            grouping: true
        }
        if(isPdf===true){
            defaultData=null
            options={paging:false}
        }
        if (!dataError) {
            if(isLoading===true){
                return (
                    <PortletContent>
                        <PerfectScrollbar>
                            <Typography
                                variant="h5"
                                >
                                <CircularProgress
                                variant="indeterminate"
                                size={24}
                                thickness={4}                            
                                />
                                <br/>
                                Cargando Información...
                            </Typography>
                        </PerfectScrollbar>
                    </PortletContent>
                )
            }else{
                //console.log('render', data)
                return(
                    <MaterialTable
                        icons={tableIcons}
                        title=""
                        columns={[
                            { title: "Día", field: "dia","defaultGroupOrder": {defaultData} },
                            { title: "paso", field: "paso" },
                            { title: "Minímo", field: "min"},
                            { title: "Maxímo", field: "max"},
                            { title: "Promedio", field: "prom"},
                        ]}
                        data={data}
                        localization={{
                            grouping: {
                                groupedBy: 'Agrupar por:',
                                placeholder: 'Arrastre los encabezados aquí, para agrupar',
                            },
                            body: {
                            emptyDataSourceMessage: 'No hay datos'
                            },
                            toolbar: {
                            searchTooltip: 'Buscar'
                            },
                            pagination: {
                            labelRowsSelect: 'Filas',
                            labelDisplayedRows: ' {from}-{to} de {count}',
                            firstTooltip: 'Pri. pág.',
                            previousTooltip: 'Pág. previa',
                            nextTooltip: 'Sig. pág.',
                            lastTooltip: 'Últ. pág'
                            }
                        }}
                        options={options}
                    />
                )
            }
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p>Error!</p>)

    }
}


export default withRouter(ResponseWeekDay);